import { useInfiniteQuery } from "@tanstack/react-query";
import axios from "axios";
import { convertEventsDTOToUrlParams, convertToEventsDTO, convertToEventsForm, EventsDTO, EventsForm } from "../../pages/Сalendar/types/CalendarTypes";

const PAGE_SIZE = 12



const useEventCards =  (
    filters: EventsForm,
  ) => {
    const  params =  useInfiniteQuery({
      queryKey: ['eventCards', filters], // Ключ кэша зависит от фильтров
      queryFn: async ({pageParam = 0}) => fetchEvents({...filters, offset:pageParam}),
      getNextPageParam: (lastPage, allPages) => {
        const cardsCount = allPages.flatMap(x=>x.data).length
        return cardsCount < lastPage.cardsCount? cardsCount : undefined;
      },
      initialPageParam: 0,
    });

    
    const cardsData = params.data?.pages.flatMap(x=>x.data) || []

    const cardsCount = params.data?.pages[0]?.cardsCount || 0
    
    const res = {...params, cardsData, cardsCount};

  return res
};

const fetchEvents = async (form: EventsForm) => {

  const myDto = convertToEventsDTO(form);

  const params = convertEventsDTOToUrlParams(myDto);

  const response = await axios.get(`/events/?${params.toString()}`);

  const cardsCount =  parseInt(response?.headers["x-total-events-count"] || '0')
  
  return {data: response.data, cardsCount};
};

export default useEventCards;